// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".therm-modal-button{text-decoration:underline;cursor:pointer}.terms-wrapper{overflow:auto;padding:25px 0;gap:14px}.terms-wrapper,.terms-wrapper div{display:flex;flex-direction:column}.terms-wrapper div{gap:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
